import React from 'react';

import {Radar, RadarChart, PolarGrid, ResponsiveContainer, PolarAngleAxis, PolarRadiusAxis} from 'recharts';
import Title from '../miscellaneous/Title';
import Paper from "@material-ui/core/Paper";
import {useStyles, types} from "../miscellaneous/constants";
import clsx from "clsx";
import Grid from "@material-ui/core/Grid";
import Tooltip from "recharts/lib/component/Tooltip";


export default function MyRadar(props) {
    const classes = useStyles();

    const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);



        return (
            <Grid item xs={12} md={6} lg={3}>
                <Title><div style={{display: 'flex', justifyContent: 'center'}}><span style={{color: '#408033'}}>{props.family}</span></div></Title>
                <ResponsiveContainer width="100%" aspect={1}>
                    <RadarChart
                        style={{
                            width: '100%',
                            height: '100%',
                            maxWidth: '500px',
                            maxHeight: '80vh',
                            aspectRatio: 1
                        }}
                        responsive
                        outerRadius="80%"
                        data={props.data}
                        margin={{
                            top: 0,
                            left: 20,
                            right: 20,
                            bottom: 20,
                        }}
                    >
                        <PolarGrid/>
                        <PolarAngleAxis dataKey="subject"/>
                        <PolarRadiusAxis domain={[0, props.nb]}/>
                        <Tooltip />
                        <Radar name="data" dataKey="score" stroke="#8884d8" fill="#8884d8" fillOpacity={0.6}/>
                    </RadarChart>
                </ResponsiveContainer>
                <br/><br/>
            </Grid>
        )





}